<div class="pl-pane__container--horizontal">
  <header class="pl-page-header pl-pane--shrink">
    <h1 class="pl-heading--xlarge">
      {{ 'CLIENT_APPROVAL.clients' | translate }}
    </h1>
  </header>




  <div *ngIf="loaded" class="pl-pane--collapse">
    <div *ngIf="!clientApprovals.length" class="pl-empty-state">
      <se-fe-empty-state seFeDataTitle="{{ 'CLIENT_APPROVAL.EMPTY.header' | translate }}">
        <se-fe-icon seFeEmptyStateIcon seFeDataName="question_thin" seFeDataSize="950" seFeDataColor="gray-900"></se-fe-icon>
        {{ 'CLIENT_APPROVAL.EMPTY.message' | translate }}
      </se-fe-empty-state>
    </div>

    <div *ngIf="clientApprovals && clientApprovals.length" class="pl-card__group">
      <div *ngFor="let clientApproval of clientApprovals" class="pl-card">
        <div class="pl-card-detail__group">
          <div class="pl-card-detail">
            <h1 class="pl-heading--xlarge">{{ clientApproval.client ? clientApproval.client.name : '' }}</h1>
          </div>
          <div class="pl-card-detail">
            <p class="pl-card-detail__label"> {{ 'CLIENT_APPROVAL.website' | translate }} </p>
            <a
              class="pl-card-detail__value--nowrap pl-link"
              href="{{clientApproval.client ? clientApproval.client.website : ''}}"
              target="_blank">
              {{ clientApproval.client ? clientApproval.client.website : '' }}
            </a>
          </div>
          <div class="pl-card-detail pl-text--right">
            <se-fe-button id="remove-client" seFeDataEmphasis="medium" (click)="removeClient(clientApproval.id)">
              <span>{{ 'CLIENT_APPROVAL.remove' | translate }}</span>
            </se-fe-button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

